export default __webpack_public_path__ + "static/media/event-sec-bg.2889c0e7.webp";